const palette = {
  neutral: {
    900: "#000528",
    800: "#2B2E40",
    700: "#434555",
    600: "#646676",
    500: "#848694",
    400: "#B0B2BD",
    300: "#dcdde3",
    350: "#D0D1D9",
    200: "#EBEBF0",
    100: "#F0F0F5",
    75: "#F6F6F9",
    50: "#FAFAFB",
    white: "#FFFFFF",
    linear: {
      white: {
        start: "rgba(255, 255, 255, 0)",
        end: "rgba(255, 255, 255, 1)",
      },
    },
    transparent: {
      white: {
        20: "rgba(255, 255, 255, 0.2)",
        90: "rgba(255, 255, 255, 0.9)",
        80: "rgba(240, 240, 245, 0.8)",
      },
    },
  },
  carot: "#198DFF",
  pending: {
    900: "#FC9403",
    500: "#FDC980",
  },
  yellow: {
    500: "#FFC42D", // TODO ca n'existe pas il faut le retirer
  },
  warning: {
    900: "#F82424",
    700: "#B91C1C",
    600: "#DC2626",
    500: "#FB9191",
    400: "#F87171",
    200: "#FECACA",
    100: "#FEF2F2",
  },
  notification: { 900: "#FB5353" },
  complete: {
    900: "#4CBC30",
    600: "#16A34A",
    500: "#A5DD97",
    100: "#F0FDF4",
  },
  system: {
    green: {
      900: "#4CBC30",
      500: "#A5DD97",
      100: "#EDFBEA",
    },
    orange: {
      900: "#FC9403",
      500: "#FDC980",
      100: "#FFF1DE",
    },
    red: {
      950: "#D41E1E",
      900: "#F82424",
      500: "#FB9191",
      100: "#FFF4F4",
    },
  },
  brand: {
    500: "#007EFC",
    100: "#E6F3FF",
    50: "#F4FBFF",
  },
  gradient: {
    blueGradient: {
      start: "#007EFC",
      end: "#3729BA",
    },
    greenGradient: {
      start: "#55B190",
      end: "#326654",
    },
    orangeGradient: {
      start: "#DFA40F",
      end: "#D1760B",
    },
    greenToBlueGradient: {
      start: "#00FC36",
      end: "#2963BA",
    },
    ribon: {
      start: "#007EFC",
      end: "#51A8FF",
    },
    reflectiveAnalysis: {
      start: "#263DC7",
      end: "#2E43C7",
    },
  },
  bubble: {
    bell: {
      start: "#DC1D8C",
      end: "#FB60BA",
    },
    pulse: {
      start: "#0465E1",
      end: "#22B4FD",
    },
    checklist: {
      start: "#FEA65A",
      end: "#FC7815",
    },
    survey: {
      start: "#EB233F",
      end: "#FF607D",
    },
    coaching: {
      start: "#33B6FF",
      end: "#4249FF",
    },
    resources: {
      start: "#008FA3",
      end: "#00BDBD",
    },
    review: {
      start: "#F5BF00",
      end: "#FF7A00",
    },
    like: {
      start: "#4FACFE",
      end: "#00CCE8",
    },
    comment: {
      start: "#EDB900",
      end: "#FFCC49",
    },
    message: {
      start: "#1FB543",
      end: "#72E78D",
    },
    other: {
      start: "#5C7390",
      end: "#6493AA",
    },
  },

  // TODO remove all bellow
  greyBlack: "rgba(0, 0, 0, 0.07)", // TODO trouver un remplacement
  hardGreyBlack: "rgba(0, 0, 0, 0.1)", // TODO trouver un remplacement
};

export default palette;
